<!-- views/layouts/MobileLayout.vue -->
<template>
    <div id="mobile-layout">
        <!-- 导航栏 -->
        <div class="mobile-nav" v-if="showNav">
            <div class="nav-left">
                <button class="nav-btn" @click="goBack" v-if="canGoBack">
                    <span class="icon">←</span>
                    <span>返回</span>
                </button>
            </div>
            <div class="nav-title" v-if="pageTitle">{{ pageTitle }}</div>
            <div class="nav-right">
                <button class="nav-btn" @click="goHome">
                    <span class="icon">🏠</span>
                    <span>首页</span>
                </button>
            </div>
        </div>

        <!-- 主要内容区域 -->
        <div class="content" :class="{ 'has-nav': showNav }">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MobileLayout',
        data() {
            return {
                showNav: true,
                pageTitle: ''
            }
        },
        computed: {
            canGoBack() {
                return window.history.length > 1;
            }
        },
        watch: {
            '$route': {
                handler(route) {
                    // 使用传统语法代替可选链操作符
                    this.pageTitle = (route.meta && route.meta.title) ? route.meta.title : '';

                    // 控制导航栏显示
                    if (route.meta && route.meta.hideNav) {
                        this.showNav = false;
                    } else {
                        this.showNav = true;
                    }
                },
                immediate: true
            }
        },
        methods: {
            goBack() {
                if (window.history.length > 1) {
                    this.$router.go(-1);
                } else {
                    this.goHome();
                }
            },

            goHome() {
                this.$router.push('/backhome');
            }
        }
    }
</script>

<style scoped>
    #mobile-layout {
        width: 100%;
        height: 100vh;
        margin: 0;
        padding: 0;
        overflow-x: hidden;
        display: flex;
        flex-direction: column;
        background-color: #f5f5f5;
    }

    .mobile-nav {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        padding: 0 12px;
        background-color: #ffffff;
        border-bottom: 1px solid #e0e0e0;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        position: sticky;
        top: 0;
        z-index: 1000;
    }

    .nav-left, .nav-right {
        flex: 0 0 auto;
        min-width: 60px;
    }

    .nav-right {
        text-align: right;
    }

    .nav-title {
        flex: 1;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0 8px;
    }

    .nav-btn {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 6px 10px;
        border: none;
        background: transparent;
        color: #007aff;
        font-size: 14px;
        cursor: pointer;
        border-radius: 4px;
        transition: background-color 0.2s;
    }

        .nav-btn:active {
            background-color: rgba(0, 122, 255, 0.1);
        }

        .nav-btn .icon {
            font-size: 18px;
            line-height: 1;
        }

    .content {
        flex: 1;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        background-color: #f5f5f5;
    }

        .content.has-nav {
            height: calc(100vh - 50px);
        }

    @media (max-width: 480px) {
        .nav-title {
            font-size: 15px;
        }

        .nav-btn span:last-child {
            display: none;
        }

        .nav-btn .icon {
            font-size: 20px;
        }
    }
</style>